import React from 'react';
import { useTypewriter } from '../hooks/useTypewriter';
import { Language } from '../types';

interface TypewriterTextareaProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  lang: Language;
  words: { zh: string[]; en: string[] };
  className?: string;
}

const TypewriterTextarea: React.FC<TypewriterTextareaProps> = ({ 
  value, 
  onChange, 
  lang, 
  words, 
  className 
}) => {
  const typewriterPlaceholder = useTypewriter(words[lang] || words.en, {
    typingSpeed: 100,
    deletingSpeed: 50,
    pauseTime: 2000,
    switchInterval: 500,
    minSubIndex: lang === 'zh' ? 6 : 19
  });

  return (
    <textarea
      value={value}
      onChange={onChange}
      placeholder={value ? "" : typewriterPlaceholder}
      className={className}
    />
  );
};

export default React.memo(TypewriterTextarea);
